import { DefaultContainer } from '@/components/DefaultContainer';
import { Box, Typography } from '@mui/material';
import { useReward } from 'partycles';
import { useEffect } from 'react';

export const SubscriptionSuccess = () => {
  const { reward, isAnimating } = useReward('rewardBox', 'confetti', { elementSize: 10, particleCount: 120 });
  useEffect(() => {
    reward();
  }, [isAnimating]);

  return (
    <DefaultContainer>
      <Box id="rewardBox" sx={{ height: '100vh', alignContent: 'center', alignItems: 'center', justifyContent: 'center', justifyItems: 'center' }}>
        <Typography sx={{ my: 3.5, fontFamily: 'Bungee Spice', fontWeight: 400, textAlign: 'center', fontSize: 46 }} variant="h4" gutterBottom>
          You now got a premium account!
        </Typography>
        {/* <Typography sx={{}}>You successfully upgraded your account to premium !</Typography> */}
      </Box>
    </DefaultContainer>
  );
};
